import { ObjectValues } from 'types';
import WarningExclamationIcon from 'icons/WarningExclamation.icon';
import SendIcon from 'icons/Send.icon';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import { IconProp } from './Icon';
import XcircleIcon from 'icons/Xcircle.icon';

export const NDA_STATUSES = {
  NOT_SENT: 'not_sent',
  SENT: 'sent',
  SIGNED: 'signed',
  COUNTER_SIGNATURE_PENDING: 'counter_signature_pending',
  REJECTED: 'rejected',
} as const;

export type NdaStatus = ObjectValues<typeof NDA_STATUSES>;

export const NDA_COPIES: Record<NdaStatus, string> = {
  [NDA_STATUSES.NOT_SENT]: 'notSentNDA',
  [NDA_STATUSES.SENT]: 'sentNDA',
  [NDA_STATUSES.SIGNED]: 'signedNDA',
  [NDA_STATUSES.COUNTER_SIGNATURE_PENDING]: 'ndaCounterPending',
  [NDA_STATUSES.REJECTED]: 'ndaRejected',
} as const;

export const NDA_COPIES_WITHOUT_NAME: Record<NdaStatus, string> = {
  [NDA_STATUSES.NOT_SENT]: 'notSentNDAStatus',
  [NDA_STATUSES.SENT]: 'sentNDAStatus',
  [NDA_STATUSES.SIGNED]: 'signedNDAStatus',
  [NDA_STATUSES.COUNTER_SIGNATURE_PENDING]: 'ndaCounterPendingStatus',
  [NDA_STATUSES.REJECTED]: 'ndaRejectedStatus',
} as const;

export const NDA_ICON: Record<NdaStatus, IconProp> = {
  [NDA_STATUSES.NOT_SENT]: WarningExclamationIcon,
  [NDA_STATUSES.SENT]: SendIcon,
  [NDA_STATUSES.SIGNED]: CheckcircleIcon,
  [NDA_STATUSES.REJECTED]: XcircleIcon,
  [NDA_STATUSES.COUNTER_SIGNATURE_PENDING]: WarningExclamationIcon,
} as const;

export const NDA_COLORS: Record<NdaStatus, string> = {
  [NDA_STATUSES.NOT_SENT]: 'silver',
  [NDA_STATUSES.SENT]: 'blue',
  [NDA_STATUSES.SIGNED]: 'green',
  [NDA_STATUSES.COUNTER_SIGNATURE_PENDING]: 'blue',
  [NDA_STATUSES.REJECTED]: 'red',
} as const;

export type NDATemplate = {
  name: string;
  templateId: string;
};
